module.exports = __webpack_public_path__ + "img/logo-footer.c78178a1.png";